module.exports = __webpack_public_path__ + "img/formsTrapezSSL.4a81845d.svg";